import React from 'react';
import HomeIcon from '../assets/images/home-grey.svg';
import EducationIcon from '../assets/images/graduate-icon.svg';
import ReadMore from './ReadMore';

function ExpertsTooltip({ name, qualification, bio, location }) {
  return (
    <div className='expertsTooltip'>
      <div className='expertsBottomSheet'>
        <div className='expertsBottomSheetTopContent'>
          <div className='expertsBottomSheetContent'>
            <h5>{name}</h5>
            {qualification && (
              <p>
                <img src={EducationIcon} alt='' />
                {qualification}
              </p>
            )}
            {location && (
              <p>
                <img src={HomeIcon} alt='' />
                {location}
              </p>
            )}
          </div>
        </div>
        {bio && <ReadMore content={bio} charLimit={200} readMoreText='More' readLessText='Less' />}
      </div>
    </div>
  );
}

export default ExpertsTooltip;
